import { FunctionComponent, PropsWithChildren } from "react";

import dynamic from "next/dynamic";

import { DashboardMobilePopupDisplayProps } from "./types";

export type { DashboardMobilePopupDisplayProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
export const DashboardMobilePopupDisplay = dynamic(
  () => import("./DashboardMobilePopupDisplaySsr").then((mod) => mod.DashboardMobilePopupDisplaySsr),
  { ssr: false }
) as FunctionComponent<PropsWithChildren<DashboardMobilePopupDisplayProps>>;
